(() => {
  'use strict';
  const root = document.documentElement;
  const banner = document.querySelector('#vonela-cookie-banner');
  const accessibility = document.querySelector('.vonela-accessibility');
  const trigger = accessibility?.querySelector('.vonela-accessibility__trigger');
  const panel = accessibility?.querySelector('#vonela-accessibility-panel');
  const status = panel?.querySelector('[data-a11y-status]');
  const readPreference = () => {
    try { return document.cookie.split('; ').find(value => value.startsWith('vonela_cookie_consent='))?.split('=').slice(1).join('='); }
    catch { return null; }
  };
  const isDismissed = () => {
    try { return sessionStorage.getItem('vonela_cookie_notice_dismissed') === '1'; }
    catch { return false; }
  };
  const syncBannerHeight = () => {
    root.style.setProperty("--vonela-cookie-height", banner && !banner.hidden ? Math.ceil(banner.getBoundingClientRect().height) + "px" : "0px");
  };
  const hideBanner = () => {
    if (!banner) return;
    const hadFocus = banner.contains(document.activeElement);
    banner.hidden = true;
    syncBannerHeight();
    if (hadFocus) trigger?.focus({ preventScroll: true });
  };
  if (banner) {
    banner.hidden = ['essential', 'accepted'].includes(readPreference()) || isDismissed();
    syncBannerHeight();
    if (typeof ResizeObserver !== "undefined") new ResizeObserver(syncBannerHeight).observe(banner);
    window.addEventListener("resize", syncBannerHeight);
    banner.querySelector('[data-cookie-dismiss]')?.addEventListener('click', () => {
      // A dismissal is not consent: remember it for this tab only, separately.
      try { sessionStorage.setItem('vonela_cookie_notice_dismissed', '1'); } catch { /* Storage may be unavailable. */ }
      hideBanner();
    });
    banner.querySelectorAll('[data-cookie-choice]').forEach(button => button.addEventListener('click', () => {
      // UI preference only. This does not enable/disable Shopify or analytics cookies.
      try {
        document.cookie = 'vonela_cookie_consent=' + encodeURIComponent(button.dataset.cookieChoice) + '; path=/; max-age=15552000; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
      } catch { /* Keep the notice dismissible even when cookies are unavailable. */ }
      try { sessionStorage.setItem('vonela_cookie_notice_dismissed', '1'); } catch { /* Storage may be unavailable. */ }
      hideBanner();
    }));
  }
  const purchaseDock = document.querySelector('.vp-sticky');
  if (purchaseDock && accessibility) {
    let dockFrame = 0;
    const syncDockObstacle = () => {
      dockFrame = 0;
      const box = purchaseDock.getBoundingClientRect();
      const visible = !purchaseDock.hasAttribute('data-floating-return') && !purchaseDock.hidden && getComputedStyle(purchaseDock).display !== 'none' && box.height > 0;
      root.style.setProperty('--vonela-dock-obstacle-bottom', visible ? Math.max(0, innerHeight - box.top + 20) + 'px' : '0px');
    };
    const queueDock = () => { if (!dockFrame) dockFrame = requestAnimationFrame(syncDockObstacle); };
    new MutationObserver(queueDock).observe(purchaseDock, { attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(queueDock).observe(purchaseDock);
    window.addEventListener('resize', queueDock, { passive: true });
    syncDockObstacle();
  }
  if (!trigger || !panel) return;
  const key = 'vonela_accessibility_v2';
  const defaults = () => ({ focus:false, pause:false, view:false, mode:'', font:1, readable:false, links:false, headings:false, alt:false, cursor:'' });
  let prefs = defaults();
  let canSave = true;
  try {
    const value = JSON.parse(localStorage.getItem(key) || '{}');
    for (const name of ['focus','pause','view','readable','links','headings','alt']) prefs[name] = value[name] === true;
    if (['mono','light','invert'].includes(value.mode)) prefs.mode = value.mode;
    if (['black','white'].includes(value.cursor)) prefs.cursor = value.cursor;
    if (typeof value.font === 'number') prefs.font = Math.max(.9, Math.min(1.4, Math.round(value.font * 10) / 10));
    localStorage.setItem(key, JSON.stringify(prefs));
  } catch { canSave = false; }
  const buttons = [...panel.querySelectorAll('[data-ax-action]')];
  const tooltip = document.querySelector('#vonela-image-description');
  const savedStyles = new Map();
  const imageAttrs = new Map();
  const pausedVideos = new Set();
  const pausedAnimations = new Set();
  const pausedSlides = new Set();
  const classes = ['focus','pause','view','readable','links','headings','alt','resize','mono','light','invert','cursor-black','cursor-white'];
  const textTags = 'h1,h2,h3,h4,h5,h6,p,li,a,button,label,input,textarea,select,summary,td,th,dt,dd,figcaption,blockquote,span,strong,em,small';
  let currentImage = null;
  let refreshTimer = 0;
  let rendering = false;
  const excluded = element => !element || element.closest('.vonela-accessibility,#vonela-image-description,script,style,noscript,template');
  const setStyle = (element, property, value) => {
    let previous = savedStyles.get(element);
    if (!previous) { previous = new Map(); savedStyles.set(element, previous); }
    if (!previous.has(property)) previous.set(property, { value:element.style.getPropertyValue(property), priority:element.style.getPropertyPriority(property) });
    element.style.setProperty(property, value, 'important');
  };
  const restoreStyles = () => {
    savedStyles.forEach((properties, element) => properties.forEach((old, property) => {
      if (old.value) element.style.setProperty(property, old.value, old.priority);
      else element.style.removeProperty(property);
    }));
    savedStyles.clear();
  };
  const setPanelOpen = (open, restore = true) => {
    panel.hidden = !open;
    root.classList.toggle('vax-panel-open',open);
    trigger.setAttribute('aria-expanded', String(open));
    trigger.setAttribute('aria-label', open ? 'סגירת כלי נגישות' : 'פתיחת כלי נגישות');
    if (open) panel.querySelector('[data-a11y-close]')?.focus({ preventScroll:true });
    else if (restore) trigger.focus({ preventScroll:true });
  };
  const gray = color => color.replace(/rgba?\(([^)]+)\)/g, (full, raw) => {
    const n = raw.split(/[ ,/]+/).filter(Boolean).map(Number);
    if (n.length < 3 || n.some(v => !Number.isFinite(v))) return full;
    const y = Math.round(.2126*n[0] + .7152*n[1] + .0722*n[2]);
    return n.length > 3 ? `rgba(${y}, ${y}, ${y}, ${n[3]})` : `rgb(${y}, ${y}, ${y})`;
  });
  const alpha = color => color === 'transparent' || /rgba\([^)]*,\s*0\s*\)$/.test(color);
  const scaleText = () => {
    if (prefs.font === 1) return;
    const elements = [...document.querySelectorAll(textTags)].filter(e => !excluded(e) && e.getAttribute('type') !== 'hidden' && ([...e.childNodes].some(n => n.nodeType === 3 && n.textContent.trim()) || e.matches('input,textarea,select')));
    const transitions = elements.map(e => ({ e, value:e.style.getPropertyValue('transition-property'), priority:e.style.getPropertyPriority('transition-property') }));
    for (const {e} of transitions) e.style.setProperty('transition-property', 'none', 'important');
    try {
      const values = elements.map(e => ({ e, size:parseFloat(getComputedStyle(e).fontSize), line:getComputedStyle(e).lineHeight }));
      for (const {e,size,line} of values) {
        if (!Number.isFinite(size)) continue;
        const floor = Math.min(size, e.matches('p,li,input,textarea,select,label') ? 16 : 14);
        setStyle(e, 'font-size', Math.max(floor, size * prefs.font) + 'px');
        if (e.matches('p,li,label') && Number.isFinite(parseFloat(line))) setStyle(e, 'line-height', String(Math.max(1.5, parseFloat(line) / size)));
      }
      void document.documentElement.offsetHeight;
    } finally {
      for (const {e,value,priority} of transitions) {
        if (value) e.style.setProperty('transition-property', value, priority);
        else e.style.removeProperty('transition-property');
      }
    }
  };
  const paintColors = () => {
    if (!prefs.mode) return;
    const elements = [document.body, ...document.body.querySelectorAll('*')].filter(e => !excluded(e) && !e.matches('svg *,source,link,meta,iframe'));
    const data = elements.map(e => { const s=getComputedStyle(e);return { e, color:s.color, background:s.backgroundColor, image:s.backgroundImage, top:s.borderTopColor, right:s.borderRightColor, bottom:s.borderBottomColor, left:s.borderLeftColor, filter:s.filter }; });
    for (const item of data) {
      const {e} = item;
      if (prefs.mode === 'mono') {
        setStyle(e,'color',gray(item.color));setStyle(e,'background-color',gray(item.background));
        for (const [side,value] of [['top',item.top],['right',item.right],['bottom',item.bottom],['left',item.left]]) setStyle(e,`border-${side}-color`,gray(value));
        if (item.image.includes('gradient(')) setStyle(e,'background-image',gray(item.image));
        if (e.matches('img,video,svg,canvas')) setStyle(e,'filter',(item.filter === 'none' ? '' : item.filter + ' ') + 'grayscale(1)');
      } else {
        const dark=prefs.mode === 'invert';
        const owner=e.closest('button,[role="button"],a.button,a[class*="button"],a.vp-button');
        const foreground=dark ? '#ffffff' : '#111111', background=dark ? '#111111' : '#ffffff';
        setStyle(e,'color',owner ? (dark ? '#111111' : '#ffffff') : (e.closest('a') ? (dark ? '#9addff' : '#1c526e') : foreground));
        if (owner) setStyle(e,'background-color',dark ? '#ffffff' : '#111111');
        else if (!alpha(item.background) || e.matches('p,h1,h2,h3,h4,h5,h6,label,input,textarea,select,li,a')) setStyle(e,'background-color',background);
        if (item.image.includes('gradient(') && !item.image.includes('url(')) setStyle(e,'background-image','none');
        for (const side of ['top','right','bottom','left']) setStyle(e,`border-${side}-color`,dark ? '#c5d2d9' : '#41525c');
      }
    }
  };
  const meaningfulImages = () => [...document.images].filter(e => !excluded(e) && e.alt.trim() && !e.closest('[aria-hidden="true"]') && e.getBoundingClientRect().width > 0 && e.getBoundingClientRect().height > 0);
  const hideDescription = () => {
    if (currentImage && imageAttrs.has(currentImage)) {
      const original=imageAttrs.get(currentImage).description;
      if (original === null) currentImage.removeAttribute('aria-describedby');else currentImage.setAttribute('aria-describedby',original);
    }
    currentImage=null;
    if (tooltip) tooltip.hidden=true;
  };
  const syncImages = () => {
    if (!prefs.alt) {
      hideDescription();imageAttrs.forEach((old,e) => { if(old.tab === null)e.removeAttribute('tabindex');else e.setAttribute('tabindex',old.tab);if(old.description===null)e.removeAttribute('aria-describedby');else e.setAttribute('aria-describedby',old.description); });imageAttrs.clear();return;
    }
    for (const img of meaningfulImages()) if (!imageAttrs.has(img)) { imageAttrs.set(img,{tab:img.getAttribute('tabindex'),description:img.getAttribute('aria-describedby')});if(img.getAttribute('tabindex')===null)img.tabIndex=0; }
  };
  const showDescription = img => {
    if (!prefs.alt || !tooltip || !imageAttrs.has(img)) return;
    hideDescription();currentImage=img;tooltip.textContent=img.alt.trim();tooltip.hidden=false;
    const old=imageAttrs.get(img).description;img.setAttribute('aria-describedby',[old,'vonela-image-description'].filter(Boolean).join(' '));
    const r=img.getBoundingClientRect(),box=tooltip.getBoundingClientRect();
    tooltip.style.left=Math.max(12,Math.min(innerWidth-box.width-12,r.left))+'px';
    tooltip.style.top=Math.max(12,Math.min(innerHeight-box.height-12,r.bottom+8))+'px';
  };
  const syncMotion = () => {
    if (prefs.pause) {
      for (const animation of document.getAnimations()) {
        const target=animation.effect?.target;
        if (!(target instanceof Element) || excluded(target)) continue;
        const timing=animation.effect.getComputedTiming();
        if (Number.isFinite(timing.endTime)) { try { animation.finish(); } catch {} }
        else if (animation.playState === 'running') { pausedAnimations.add(animation);animation.pause(); }
      }
      for (const video of document.querySelectorAll('video[autoplay]')) if (!video.paused) {pausedVideos.add(video);video.pause();}
      for (const slide of document.querySelectorAll('slideshow-component')) if (slide.querySelector('[data-autoplay="true"]') && typeof slide.pause === 'function' && !pausedSlides.has(slide)) {if(slide.autoplayButtonIsSetToPlay !== false)pausedSlides.add(slide);slide.pause();}
    } else {
      pausedAnimations.forEach(animation => { if(animation.effect?.target?.isConnected)animation.play(); });pausedAnimations.clear();
      pausedVideos.forEach(video => { if(video.isConnected && !matchMedia('(prefers-reduced-motion: reduce)').matches)video.play()?.catch(()=>{}); });pausedVideos.clear();
      pausedSlides.forEach(slide => { if(slide.isConnected && typeof slide.play==='function')slide.play(); });pausedSlides.clear();
    }
  };
  const active = action => ['mono','light','invert'].includes(action) ? prefs.mode === action : action.startsWith('cursor-') ? prefs.cursor === action.slice(7) : action === 'font-up' ? prefs.font > 1 : action === 'font-down' ? prefs.font < 1 : prefs[action] === true;
  const syncButtons = () => {
    buttons.forEach(button => { const action=button.dataset.axAction;if(action!=='reset')button.setAttribute('aria-pressed',String(active(action)));if(action==='font-up')button.disabled=prefs.font>=1.4;if(action==='font-down')button.disabled=prefs.font<=.9; });
    const level=panel.querySelector('[data-ax-font-level]');if(level)level.textContent=Math.round(prefs.font*100)+'%';
    const note=panel.querySelector('[data-ax-save-note]');if(note)note.textContent=canSave?'ההעדפות נשמרות בדפדפן זה בלבד.':'ההעדפות חלות בביקור הנוכחי.';
  };
  const render = () => {
    if (rendering) return;rendering=true;
    restoreStyles();
    for (const name of classes) root.classList.remove('vax-'+name);
    for (const name of ['focus','pause','view','readable','links','headings','alt']) if(prefs[name])root.classList.add('vax-'+name);
    if(prefs.font!==1)root.classList.add('vax-resize');
    if(prefs.mode)root.classList.add('vax-'+prefs.mode);
    if(prefs.cursor)root.classList.add('vax-cursor-'+prefs.cursor);
    scaleText();paintColors();syncImages();syncMotion();syncButtons();rendering=false;
  };
  const save = () => {try {localStorage.setItem(key,JSON.stringify(prefs));}catch{canSave=false;}};
  trigger.addEventListener('click',()=>setPanelOpen(panel.hidden));
  panel.querySelector('[data-a11y-close]')?.addEventListener('click',()=>setPanelOpen(false));
  buttons.forEach(button=>button.addEventListener('click',()=>{
    const action=button.dataset.axAction;
    if(action==='reset'){prefs=defaults();try{localStorage.removeItem(key);}catch{}}else if(action==='font-up'||action==='font-down'){prefs.font=Math.max(.9,Math.min(1.4,Math.round((prefs.font+(action==='font-up'?.1:-.1))*10)/10));}else if(['mono','light','invert'].includes(action)){prefs.mode=prefs.mode===action?'':action;}else if(action.startsWith('cursor-')){const value=action.slice(7);prefs.cursor=prefs.cursor===value?'':value;}else if(Object.hasOwn(prefs,action)){prefs[action]=!prefs[action];}
    if(action!=='reset')save();render();
    if(status)status.textContent=action==='reset'?'כל ההתאמות אופסו':action.startsWith('font-')?'גודל טקסט '+Math.round(prefs.font*100)+' אחוז':button.innerText.replace('✓','').trim()+(active(action)?' הופעל':' כובה');
  }));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden){event.preventDefault();hideDescription();setPanelOpen(false);}});
  document.addEventListener('pointerdown',event=>{if(!panel.hidden&&!accessibility.contains(event.target))setPanelOpen(false,false);});
  accessibility.addEventListener('focusout',event=>{if(!panel.hidden&&event.relatedTarget&&!accessibility.contains(event.relatedTarget))setPanelOpen(false,false);});
  document.addEventListener('pointerover',event=>{if(event.target instanceof HTMLImageElement)showDescription(event.target);});
  document.addEventListener('pointerout',event=>{if(event.target===currentImage&&document.activeElement!==currentImage)hideDescription();});
  document.addEventListener('focusin',event=>{if(event.target instanceof HTMLImageElement)showDescription(event.target);else if(currentImage)hideDescription();});
  document.addEventListener('play',event=>{if(prefs.pause&&event.target instanceof HTMLVideoElement&&event.target.autoplay){pausedVideos.add(event.target);event.target.pause();}},true);
  const refresh=()=>{clearTimeout(refreshTimer);refreshTimer=setTimeout(()=>{if(Object.entries(prefs).some(([k,v])=>k==='font'?v!==1:Boolean(v)))render();},80);};
  new MutationObserver(records=>{if(records.some(record=>!excluded(record.target instanceof Element?record.target:record.target.parentElement)&&(record.type==='childList'||prefs.pause)))refresh();}).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  document.addEventListener('animationstart',()=>{if(prefs.pause)refresh();},true);
  if (!CSS.supports('zoom','1.1')) { prefs.view=false;panel.querySelector('[data-ax-action="view"]')?.setAttribute('hidden',''); }
  render();
})();
